// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9bc78dd2","513":"dbffd220","703":"874bc9d6"}[chunkId] + ".chunk.js";
};